var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36Z",
    fill: "#345D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2337 38.1507L32.4334 50.79H52.7603C52.8949 50.7853 53.0292 50.8069 53.1554 50.8534C53.2816 50.9 53.3972 50.9706 53.4957 51.0613C53.5942 51.152 53.6736 51.2609 53.7294 51.3819C53.7852 51.5028 53.8163 51.6334 53.8208 51.7662V52.0975L52.0533 58.112C51.9753 58.3964 51.8017 58.6463 51.5608 58.8205C51.3199 58.9948 51.0261 59.083 50.7276 59.0708H19.6186L24.8329 41.5503L19 43.2936L20.3257 39.2839L26.1586 37.5406L33.4939 12.9595C33.5747 12.6766 33.7491 12.4286 33.9893 12.2548C34.2296 12.0811 34.5218 11.9916 34.8196 12.0006H42.6852C42.8199 11.996 42.9541 12.0175 43.0803 12.0641C43.2065 12.1106 43.3222 12.1813 43.4207 12.2719C43.5192 12.3626 43.5986 12.4715 43.6544 12.5925C43.7101 12.7135 43.7412 12.8441 43.7458 12.9769V13.3081L37.5593 34.0539L43.3923 32.3106L42.155 36.4946L36.2337 38.1507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.f24e2cd2cbcfdef8c53ebfdeb88698e3.svg";
export { ForwardRef as ReactComponent };